import React from "react";

export default function SEOContent() {
    return (
        <section
            data-testid="seo-content-section"
            className="relative py-24 md:py-32 border-t border-white/5 bg-[#080808]"
        >
            <div className="max-w-4xl mx-auto px-6 md:px-12">
                <span className="text-xs tracking-[0.25em] uppercase text-[#D4AF37]">
                    Tentang Kami
                </span>
                <h2 className="mt-4 text-3xl md:text-5xl font-medium tracking-tighter text-white">
                    PUSATCUAN — <span className="text-gold-gradient">Pusat Cuan</span> Hiburan
                    Digital Indonesia
                </h2>

                <div className="mt-8 space-y-6 text-white/70 leading-relaxed text-base md:text-lg">
                    <p>
                        <strong className="text-white">PUSATCUAN</strong> hadir sebagai{" "}
                        <strong className="text-white">platform hiburan digital</strong>{" "}
                        modern yang dirancang untuk memberikan pengalaman terbaik bagi
                        para penggemar game online di Indonesia. Sebagai{" "}
                        <em className="text-[#D4AF37]">
                            situs hiburan no 1 Indonesia
                        </em>
                        , kami menghadirkan ribuan game online terbaru — mulai dari{" "}
                        <strong className="text-white">pusatcuan slot</strong>, live
                        casino, hingga sportsbook — dalam satu akses mudah melalui{" "}
                        <strong className="text-[#D4AF37]">link resmi terpercaya</strong>.
                    </p>

                    <h3 className="text-xl md:text-2xl font-medium text-white pt-4">
                        Pusat Cuan Sebagai Situs Hiburan Online Terpercaya
                    </h3>
                    <p>
                        Dengan komitmen pada kualitas layanan, <strong className="text-white">pusat cuan</strong>{" "}
                        PUSATCUAN terus berinovasi menghadirkan teknologi keamanan
                        terkini, integrasi pembayaran lokal, serta katalog provider resmi
                        kelas dunia seperti Pragmatic Play, PG Soft, Microgaming, dan
                        Evolution Gaming. Semua ini membuat kami diakui sebagai{" "}
                        <strong className="text-white">
                            situs hiburan online terpercaya
                        </strong>{" "}
                        pilihan jutaan member aktif.
                    </p>

                    <h3 className="text-xl md:text-2xl font-medium text-white pt-4">
                        Akses Game Online Terbaru via Link Resmi Terpercaya
                    </h3>
                    <p>
                        Kami menyediakan{" "}
                        <strong className="text-white">akses game online terbaru</strong>{" "}
                        yang selalu diperbarui setiap minggu. Tim kami memastikan{" "}
                        <strong className="text-[#D4AF37]">link resmi terpercaya</strong>{" "}
                        tetap dapat diakses meskipun ada pembatasan jaringan — sehingga
                        Anda bisa menikmati pengalaman bermain tanpa gangguan di mana pun
                        Anda berada.
                    </p>

                    <h3 className="text-xl md:text-2xl font-medium text-white pt-4">
                        Mengapa Memilih PUSATCUAN Sebagai Situs Game Online Terpercaya?
                    </h3>
                    <ul className="list-disc pl-6 space-y-2 marker:text-[#D4AF37]">
                        <li>
                            Sistem keamanan enkripsi SSL 256-bit dan proteksi anti-DDoS.
                        </li>
                        <li>
                            Proses transaksi super cepat — deposit &amp; withdraw di
                            bawah 3 menit.
                        </li>
                        <li>
                            Tim CS profesional siap siaga 24 jam setiap hari via live
                            chat.
                        </li>
                        <li>
                            Katalog permainan lengkap: pusatcuan slot, live casino, sports,
                            arcade, dan poker.
                        </li>
                        <li>
                            Metode pembayaran fleksibel: bank lokal, e-wallet, dan pulsa
                            tanpa potongan.
                        </li>
                        <li>
                            Multi-link alternatif anti-blokir untuk memastikan akses
                            lancar.
                        </li>
                    </ul>

                    <p className="pt-4">
                        Bergabunglah bersama PUSATCUAN hari ini dan rasakan sendiri
                        mengapa kami disebut{" "}
                        <strong className="text-white">
                            platform hiburan digital terbaik & link resmi terpercaya
                        </strong>{" "}
                        di Indonesia.
                    </p>
                </div>
            </div>
        </section>
    );
}
